import React, { useEffect, useState } from 'react';
import './index.css'
import './HomePage.css'; // Asumimos que los estilos específicos y las imágenes se manejan a través de un archivo CSS
import grupo_1069 from '../../images/homePage/Grupo_1069.png'
import BackgroundImage from '../../common/BackgroundImage';
import { Button, Col, Row } from 'antd';
import iconClickProfile from '../../images/homePage/btn-click-profile@3x.png'
import iconClickProfileFr from '../../images/homePage/btn-click-profile-fr.png'
import logoIRGT from '../../images/homePage/inrgt-logo@3x.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { DICTIONARY } from '../../utilities/dictionary';
import { registerLogEvent } from '../../firebase/endpoints';
import { EventsName } from '../../models/events.models';

const HomePage: React.FC = () => {
    const navigate = useNavigate();

    const location = useLocation();

    // Handlers
    const nextPage = () => {
        if (location.pathname === '/en') {
            navigate("/en/introduction");

        } else {
            navigate("/fr/introduction");

        }
    }

    // Effects
    useEffect(() => {
        registerLogEvent('view_item', { view_name: EventsName.LANDING_PAGE, language: location.pathname === '/en' ? 'English' : 'French' })
        const startTime = Date.now();
        registerLogEvent('navigate', { view_name: EventsName.LANDING_PAGE, language: location.pathname === '/en' ? 'English' : 'French' })

        return () => {
            const duration = Date.now() - startTime;

            if (location.pathname === '/en') {
                registerLogEvent('view_duration', { view_name: EventsName.LANDING_PAGE, duration, language: 'English' })

            } else if (location.pathname === '/fr') {
                registerLogEvent('view_duration', { view_name: EventsName.LANDING_PAGE, duration, language: 'French' })
            }
        };
    }, [location.pathname]);

    const useWindowDimensions = () => {
        const [windowDimensions, setWindowDimensions] = useState({
            width: window.innerWidth,
            height: window.innerHeight
        });

        useEffect(() => {
            const handleResize = () => {
                setWindowDimensions({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return windowDimensions;
    };

    const { width, height } = useWindowDimensions();

    console.log(width, height)

    return (
        <div className='container'>
            <BackgroundImage />
            <Row style={{ height: '100%', width: '100%', zIndex: 3, overflowY: 'auto' }}>
                <Col xl={{ span: 12 }} xxl={{ span: 12 }} className='container-section-one'>
                    <img alt='logo-irgt' src={logoIRGT} style={{ height: 'auto', width: '150px', top: '150px', position: 'absolute' }} />
                    <span className='title-home'>
                        {DICTIONARY['home_title_one'][location.pathname.split('/')[1] === 'en' ? 'English' : 'French']}
                    </span>
                    <span className='subtitle-home'>{DICTIONARY['home_subtitle_one'][location.pathname.split('/')[1] === 'en' ? 'English' : 'French']}</span>

                </Col>
                <Col xl={{ span: 12 }} xxl={{ span: 12 }} className='container-section-two'>
                    <Button
                        onClick={nextPage}
                        className='button-click'
                        icon={<img alt="icon sale force" src={location.pathname.split('/')[1] === 'en' ? iconClickProfile : iconClickProfileFr}
                            style={{ height: '144px', width: 'auto' }} />}
                    />

                    <img className='image-cellphone' src={grupo_1069} alt='grupo_1069' />

                </Col>
            </Row>
        </div >
    );
}

export default HomePage;
